var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFolder = function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M22 18.471V9.75c0-1.243-.995-2.25-2.222-2.25H13.11l-2.303-3.498A2.22 2.22 0 0 0 8.958 3H4.223C2.995 3 2 4.007 2 5.25v13.5C2 19.993 2.995 21 4.222 21h15.556C21.005 21 22 19.993 22 18.75",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgFolder;